export default __webpack_public_path__ + "static/media/faqicon4.73cdbbea.svg";